function createModal(url) {
	var modal = $('<div id="modalHolder" style="z-index: 1000;"><div class="close"></div><iframe src="' + url + '"></iframe></div>').appendTo(
		$('body'));
	modal.find('.close').one('click', function () {
		modal.remove();
	})
}
